import { replace } from 'lodash';

import AjaxCart from 'api/AjaxCart';
import StorefrontCart from 'api/StorefrontCart';
import Settings from 'utils/Settings';

class CartAPI {
  static fetchCart(...args) {
    if (Settings.storefrontCartEnabled) {
      return StorefrontCart.fetchCart(...args);
    }
    return AjaxCart.fetchCart(...args);
  }

  static addLineItems(...args) {
    if (Settings.storefrontCartEnabled) {
      return StorefrontCart.addLineItems(...args);
    }
    return AjaxCart.addLineItems(...args);
  }

  static updateLineItem(...args) {
    if (Settings.storefrontCartEnabled) {
      return StorefrontCart.updateLineItem(...args);
    }
    return AjaxCart.updateLineItem(...args);
  }

  static removeLineItem(...args) {
    if (Settings.storefrontCartEnabled) {
      return StorefrontCart.removeLineItem(...args);
    }
    return AjaxCart.removeLineItem(...args);
  }

  // Not supported in SF API
  static clearCart(...args) {
    return AjaxCart.clearCart(...args);
  }

  // Not supported in AJAX API
  static addDiscounts(...args) {
    return StorefrontCart.addDiscounts(...args);
  }

  static setAttribute(...args) {
    if (Settings.storefrontCartEnabled) {
      return StorefrontCart.setAttribute(...args);
    }
    return AjaxCart.setAttribute(...args);
  }

  /* Receive an object where the properties and values will become attributes and values in the cart
   *
   * Example:
   * {
   *  _isLoggedInToShopRunner: false,
   *  _srToken: 'unset',
   * }
   */
  static setAttributes(...args) {
    if (Settings.storefrontCartEnabled) {
      return StorefrontCart.setAttributes(...args);
    }
    return AjaxCart.setAttributes(...args);
  }

  static setGiftMessage(value) {
    // Replace all occurences of the bad apostrophe (ie "’") with good apostrophe (ie "'")
    const sanitizeGiftMessage = message => replace(message, /’/g, "'");

    return CartAPI.setAttribute('gift_message', sanitizeGiftMessage(value));
  }

  static setLogoFreePackaging(value) {
    return CartAPI.setAttribute('logo_free', value);
  }

  static setLocale(locale) {
    return CartAPI.setAttribute('locale', locale);
  }
}

export default CartAPI;
